function loginFormToggle() {
  const hashtag = window.location.hash;

  const recoverForms = document.querySelectorAll(".customer-recover__form");
  const loginForms = document.querySelectorAll(".customer-login__form");

  if (hashtag === "#recover") {
    // show recover forms, hide login forms
    recoverForms.forEach((form) => (form.style.display = "block"));
    loginForms.forEach((form) => (form.style.display = "none"));
  } else {
    // show login forms, hide recover forms
    recoverForms.forEach((form) => (form.style.display = "none"));
    loginForms.forEach((form) => (form.style.display = "block"));
  }
}

window.addEventListener("hashchange", function (event) {
  loginFormToggle();
});

(function () {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const accountButton = document.querySelector("[data-customer-icon]");
  const customerDropdown = document.querySelector("[data-customer-dropdown]");

  loginFormToggle();

  if (isLoggedIn) {
    return;
  }

  accountButton.addEventListener("click", (e) => {
    e.preventDefault();
    customerDropdown.getAttribute("open")
      ? customerDropdown.removeAttribute("open")
      : customerDropdown.setAttribute("open", true);
  });

  document.addEventListener("click", (e) => {
    if (
      customerDropdown.getAttribute("open") &&
      !accountButton.contains(e.target) &&
      !customerDropdown.contains(e.target)
    ) {
      customerDropdown.removeAttribute("open");
    }
  });
})();
